import { render, staticRenderFns } from "./videoorder.vue?vue&type=template&id=58e44d5e&scoped=true"
import script from "./videoorder.vue?vue&type=script&lang=js"
export * from "./videoorder.vue?vue&type=script&lang=js"
import style0 from "./videoorder.vue?vue&type=style&index=0&id=58e44d5e&prod&lang=scss&scoped=true"
import style1 from "./videoorder.vue?vue&type=style&index=1&id=58e44d5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e44d5e",
  null
  
)

export default component.exports